export const umpireRatingOptions = {
    plate: ["consistency", "attitude", "effort", "overall"],
    field: ["attitude", "effort", "overall"],
} as const;
